import { render, staticRenderFns } from "./UnlockCoupon.vue?vue&type=template&id=5f04f68b&scoped=true&"
import script from "./UnlockCoupon.vue?vue&type=script&lang=js&"
export * from "./UnlockCoupon.vue?vue&type=script&lang=js&"
import style0 from "./UnlockCoupon.vue?vue&type=style&index=0&id=5f04f68b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f04f68b",
  null
  
)

export default component.exports